import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserNetworkType } from 'user/model/user-network.type';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface ReconnectToUserNetworkParams {
	readonly networkRefreshTokenScope: string;
	readonly networkType: UserNetworkType;
}

@Injectable({ providedIn: 'root' })
export class ReconnectToUserNetworkApiMutation extends ApiMutation<
	void,
	ReconnectToUserNetworkParams
> {
	client = 'iam';
	document = gql`
		mutation ReconnectToUserNetwork(
			$networkType: UserNetworkType!
			$networkRefreshTokenScope: String!
		) {
			reconnectToUserNetwork(
				networkType: $networkType
				networkRefreshTokenScope: $networkRefreshTokenScope
			)
		}
	`;
	method = 'reconnectToUserNetwork';
}
